export default "__VITE_ASSET__57d6e251__"